import * as Sentry from '@sentry/node';

const handleOnImageError = (e, showDefault = true) => {
  const img = e.target;
  const error = new Error(`Image URL ${e.target.src} is invalid.`);
  Sentry.withScope((scope) => {
    scope.setLevel(Sentry.Severity.Warning);
    scope.setFingerprint(['{{default}}', 'handleOnImageError']);
    Sentry.captureException(error);
  });

  if (showDefault) {
    img.src = `${process.env.NEXT_PUBLIC_ASSET_HOST}/images/default-image.jpg`;
  }
};

export default handleOnImageError;
